export * from './base-info.component'; //BASE
export * from './vehicle-info.component';
export * from './customer-info.component';
export * from './diario-info.component';
export * from './subtotal-info.component';

